export const compareArrayByKey = (array1, array2, key) => {
  return (array1.length === array2.length) && array1.every((element, index) => {
    return element[key] === array2[index][key]
  })
}



// WEBPACK FOOTER //
// ./src/utils/compareArrayByKey.js